"use strict";

exports.__esModule = true;
exports.default = uplaodWos;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.object.keys.js");
var _util = require("./util");
var _utils = require("../utils");
var zzMedia = _utils.isServer || location.origin.includes('zhuanzhuan.com') ? 'https://mediaproxy.zhuanzhuan.com/media/upload' : 'https://mediaproxy.zhuanspirit.com/media/upload';
function uplaodWos(file, options, changeHandler) {
  file.progress = 0;
  file.status = _util.STATUS_UPLOADING;
  function setStatus(status) {
    file.progress = 1;
    file.status = status;
    changeHandler && changeHandler(file);
  }
  function setResponse(result) {
    if (result.respData) {
      file.response = result.respData.videoCover || options.videoCover;
      file.url = result.respData.video;
      file.videoHeight = result.respData.videoHigh;
      file.videoWidth = result.respData.videoWidth;
      file.recordTime = result.respData.recordTime;
    } else {
      file.response = result.videoCover || options.videoCover;
      file.url = result.data.url;
    }
    try {
      file.urlName = file.url.split('zzwos.58cdn.com.cn')[1];
    } catch (error) {
      console.error(error);
    }
  }
  function succCB(result) {
    result = JSON.parse(result);
    if (result.code === 0) {
      setResponse(result);
      setStatus(_util.STATUS_SUCCESS);
    } else {
      setStatus(_util.STATUS_ERROR);
    }
  }
  function errCB(result) {
    // alert('您的系统版本过低，请升级拍摄设备系统或直接点击拍摄上传。');
    setStatus(_util.STATUS_ERROR);
  }
  function progCB(progress) {
    // progress在触发上传成功事件时才置为1，确保loading状态不消失
    file.progress = progress < 1 ? progress : 0.99;
  }
  if (options.getVideoInfo) {
    var maxSize = 50 * 1024 * 1024;
    if (file.file.size > maxSize) {
      return setStatus(_util.STATUS_ERROR);
    }
    var data = new FormData();
    data.append('file', file.file);
    $.ajax({
      /* eslint-disable-line */
      type: 'post',
      url: zzMedia,
      xhrFields: {
        withCredentials: true
      },
      contentType: false,
      processData: false,
      crossDomain: true,
      data: data,
      xhr: function xhr() {
        var xhr = $.ajaxSettings.xhr(); /* eslint-disable-line */

        if (xhr.upload) {
          xhr.upload.addEventListener('progress', function (e) {
            if (e.lengthComputable) {
              // progress在触发上传成功事件时才置为1，确保loading状态不消失
              var progress = e.loaded / e.total;
              file.progress = progress < 1 ? progress : 0.99;
            }
          }, false);
        }
        return xhr;
      }
    }).done(function (res) {
      if (res.respCode === 0) {
        setResponse(res);
        setStatus(_util.STATUS_SUCCESS);
      } else {
        console.error(res.respMsg);
        setStatus(_util.STATUS_ERROR);
      }
    }).fail(function (res) {
      console.error(res);
      setStatus(_util.STATUS_ERROR);
    });
    return;
  }
  var bucket = 'zzfecommon';
  var appid = 'wbuTsRqPowE';
  var wosurl = '//zzwos.58.com';
  var ttl = 0;
  // insertOnly==0 表示允许覆盖文件 1表示不允许覆盖
  var insertOnly = 1;
  // 文件别名，默认不设置，如果设置，下载时通过http头中Content-Disposition字段返回
  var alias = '';
  // 大文件上传的分片大小，默认2M，支持1,2,3,4M,小文件该字段为0，不受该值影响.
  var sliceSize = 2 * 1024 * 1024;
  var lastTaskId; /* eslint-disable-line */
  var taskReady = function taskReady(taskId) {
    lastTaskId = taskId;
  };
  var md5Value = file.name + 'zzfecommonmd5' + Math.random();
  var wos = new WosSys({
    /* eslint-disable-line */
    appid: appid,
    // APPID 必填参数
    bucket: bucket,
    // bucketName 必填参数
    wosurl: wosurl,
    // wos的url 必填参数
    getAppSign: function getAppSign(callback) {
      // 获取签名 必填参数
      var extensions = ['mp4', 'mov', 'avi', 'flv'];
      var extension = (file.name.split('.')[1] || 'mp4').toLowerCase();
      var ext = extensions.includes(extension) ? extension : 'mp4';
      $.ajax({
        /* eslint-disable-line */
        type: 'post',
        url: 'https://app.zhuanzhuan.com/zz/transfer/getwostoken',
        data: {
          bucket: bucket,
          md5: md5Value,
          expire: '1200',
          // extension: file.name.split('.')[1] || 'mp4'
          extension: ext
        }
      }).done(function (res) {
        var rest = JSON.parse(res);
        var filename = rest.respData ? rest.respData.fileName : '';
        var sig = rest.respData ? rest.respData.data : '';
        callback(encodeURIComponent(sig), filename);
      }).fail(function (res) {
        // setResponse('');
        setStatus(_util.STATUS_ERROR);
      });
    }
  });
  wos.uploadFile(succCB, errCB, progCB, bucket, file.name, file.file, ttl, insertOnly, taskReady, sliceSize, alias);
}